import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation, useRouteMatch, useHistory } from "react-router-dom";

import i18n from "../../i18n";

// Series specific actions
import {
  LOAD_SERIES_DETAIL,
  loadSimilarItems,
  LOAD_SIMILAR_SERIES,
  loadSeasons,
  LOAD_SEASON_DATA,
  loadTVShowDetailItems,
  LOAD_SERIES_PAGE_CONTAINERS,
  loadSeasonEntitlements,
  LOAD_SEASON_ENTITLEMENTS,
  LOAD_SERIES_SCHEDULES,
  loadSchedules,
  LOAD_CONTENT_USERDATA,
  loadContentUserData,
  LOAD_LIST_OF_TEAMS,
  LOAD_RECENT_AIRINGS,
  LOAD_LIST_OF_GAMES,
} from "./state/actions";

import {
  resetAction,
  loadUserSubscribedChannels,
  showToastNotification,
  setConvivaContentSubType,
  showModalPopup,
  showRecordingSettingsPanel,
  ADD_FAVOURITE,
  DELETE_FAVOURITE,
  addFavourites,
  deleteFavourites,
  loadChannels,
} from "../../App/state/actions";
import {
  setRecordingAction,
  getRecordingAction,
  toggleSettingsPanelAction,
  SET_RECORDINGS,
  GET_RECORDINGS,
  EDIT_RECORDINGS,
  DELETE_RECORDINGS,
  MANIPULATE_RECORDING_ACTION_TRIGGERED,
  setTeamRecordingAction,
  SET_TEAM_RECORDINGS,
} from "../RecordingsPage/state/actions";
import Wall from "../../components/Wall";
import WallContent from "../../components/WallContent";
import constants from "../../shared/constants/index";
import recordingConstants from "../../shared/constants/recordingConstants";
import Swimlane from "../../components/Swimlane";
import swimlaneConstants from "../../shared/constants/swimlane";
import SwimlaneItem from "../../components/SwimlaneItem";
import CastSwimlaneItem from "../../components/SwimlaneItem/CastSwimlaneItem";
import MoreInformationModal from "../../components/MoreInformationModal";
import { useTranslation } from "react-i18next";
import { createSwimlaneFeedItem, createEpisodeSwimlaneItems } from "../../shared/utils/swimlane";
import createSwimlaneModels from "../../shared/utils/dataFilters";
import { getAVSKeyArtImage } from "../../shared/utils/image";
import {
  getSubTextLine1,
  getItemLiveAvailability,
  getLiveChannelAsset,
  getLookbackAvailabilityString,
  getSortedSeasons,
  getSubTextLine2,
  getDurationInMinHour,
  getSortedRecentAirings,
} from "../../shared/utils/feedHelper";
import {
  getRecordingCTAs,
  getRecordingInfo,
  setRecording,
  getRecordingSystemType,
  getRecordablePrograms,
  getCPVRRecordingStatus,
  doesCPVRSeriesRecordingExist,
  doesCPVREventRecordingExist,
  navigateToPVRManager,
  checkCPVRConflicts,
  showCPVRConflictModal,
  isRecordingPendingStateCheck,
  getRouteToPVRManager,
  isCPVRRecordingRecorded,
  isCPVRRecordingInProgress,
  getTeamRecordingParams,
  getSeriesRecordings,
} from "../../shared/utils/recordingHelper";
import {
  getPcLevelRestriction,
  seasonCompareFunction,
  calculateLookbackHoursLeft,
  getNewestLookbackProgram,
  getAutoGeneratedObject,
  findContainerByLayout,
  determine4KPlayRestriction,
  getPreferredWatchOption,
  checkIfAnyScheduleIsSubscribed,
} from "../../shared/utils";
import routeConstants from "../../shared/constants/routes";

import "./style.scss";
import SeasonPickerDropDown from "../../components/SeasonPickerDropdown";
import ImageButton from "../../components/ImageButton";
import OptikButton from "../../components/OptikButton";
import SeoPageTags from "../../components/SeoPageTags";
import { handleLogin } from "../../shared/utils/login";
import { trackGenericAction, trackRecordingError } from "../../shared/analytics/dataLayer";
import { getFirstPlayableEpisode, getPlayableEpisode } from "../../shared/utils/playbackHelpers";
import RecordingModal from "../../components/RecordingModal";
import WaysToWatchPrompt from "../../components/WaysToWatchPrompt";
import { getSessionStorage, setSessionStorage } from "../../shared/utils/sessionStorage";
import {
  ANALYTICS_STORAGE_KEYS,
  LINK_INFO,
  ANALYTICS_EVENT_TYPES,
  EXTRA_METADATA_TYPES,
  MAPPED_CONTENT_TYPES,
  SITE_NAMES,
} from "../../shared/constants/analytics";
import { useConvivaContentSubType } from "../../shared/hooks/useConvivaContentSubType";
import { getAAVideoPlayType } from "../../shared/analytics/helpers";
import { getRegionalChannelNumber, isGhostChannel, is4KChannel } from "../../shared/utils/epg";
import { formatTrackingValue } from "../../shared/utils/analytics";
import { logDTEvent, setDTPageAttributes } from "../../shared/analytics/dynatrace";

import useAppLanguage from "../../shared/hooks/useAppLanguage";
import { mapRecordingSeriesMediaContent } from "../../shared/analytics/helpers";
import useCancelTokenSource from "../../shared/hooks/useCancelTokenSource";
import useTrackPageView from "../../shared/hooks/useTrackPageView";
import EpisodeSwimlaneItem from "../../components/SwimlaneItem/EpisodeSwimlaneItem";
import playerConstants from "../../shared/constants/player";
import usePlaybackChecks from "../../shared/hooks/usePlaybackChecks";
import useDetailsPageCompositor from "../../shared/hooks/useDetailsPageCompositor";
import { getCustomContextMetadata, trackConvivaCustomEvent } from "../../shared/analytics/media";
import { loadRecordingsBookmark } from "../../pages/RecordingsPage/state/actions";
import { DT_ATTRIBUTES, DT_EVENTS } from "../../shared/constants/dynatrace";

const outHomeIcon = process.env.PUBLIC_URL + "/images/Out_of_home.svg";
const outHomeToastIcon = process.env.PUBLIC_URL + "/images/Out_of_home_toast_icon.svg";
const unSubscribedIcon = process.env.PUBLIC_URL + "/images/key-toast-icon.svg";
const playIcon = process.env.PUBLIC_URL + "/images/play-icon.svg";
const favourite_icon_active = process.env.PUBLIC_URL + "images/favourite_active.svg";
const favourite_icon = process.env.PUBLIC_URL + "images/favourite_white.svg";
const seriesInfoIcon = process.env.PUBLIC_URL + "images/ico_cta_circle.svg";

const {
  IMAGES,
  CONTENT_ITEM_TYPES,
  CONTAINER_TYPES,
  ACTION_KEYS,
  PAGE_CONTENT_ITEM_TYPES,
  MODAL_TYPES,
  LOGIN_BRANDS,
  CONTAINER_LAYOUTS,
  PLAY,
  WATCH_OPTIONS,
} = constants;
const { RECORDING_PARAMS, RECORDING_PACKAGES, MR_RECORDING_FILTER_OPTIONS } = recordingConstants;
const { ITEM_TYPES, SWIMLANE_TITLES } = swimlaneConstants;
const { SIMILAR_ITEMS, LIVE_PLAYER, ON_DEMAND_PLAYER, SERIES_DETAIL_PAGE, ALTERNATE_LOGIN } = routeConstants;
const { PLAYBACK_TYPES, ASSET_TYPES } = playerConstants;

/**
 * Movie Detail page component
 *
 * @component
 * @param {Object} props
 */

function SeriesDetailPage(props) {
  const {
    userProfile,
    appProvider,
    loadTVShowDetailItems,
    resetAction,
    similarItems,
    loadSimilarItems,
    addFavourites,
    isAddedToFavourites,
    deleteFavourites,
    loadSchedules,
    schedules,
    showToastNotification,
    loadContentUserData,
    contentUserData,
    loadSeasons,
    seasonData,
    loadSeasonEntitlements,
    seasonEntitlements,
    loadUserSubscribedChannels,
    subscribedChannels,
    setRecordingAction,
    getRecordingAction,
    setConvivaContentSubType,
    showRecordingSettingsPanel,
    showModalPopup,
    totalSimilarItems,
    toggleSettingsPanelAction,
    recordingsList,
    getRecordingError,
    setRecordingResponse,
    editRecordingResponse,
    deleteRecordingResponse,
    manipulatedRecordingParams,
    isInHome,
    featureToggles,
    loadChannels,
    channelMapInfo,
    listOfTeams,
    recentAirings,
    listOfLiveGames,
    seriesContainers,
  } = props;
  const {
    isRecordingEnabled,
    isRecommendationMLTEnabled,
    isLookbackEnabled,
    isFavouritesEnabled,
    isUserProfilesEnabled,
    isParentalPINEnabled,
    isConvivaAppTrackerEnabled,
    isKoodoLoginEnabled,
    is4KVodEnabled,
    isCPVRBookmarksEnabled,
    isAlternateLoginEnabled,
    isDynatraceTrackingEnabled,
    isTeamRecordingsEnabled,
  } = featureToggles;
  const dispatch = useDispatch();

  const [loadComponent] = useState(true);
  const [priorityEpisode, setPriorityEpisode] = useState(null);
  const [showRecordingModal, setShowRecordingModal] = useState(false);
  const liveItem = useRef(0);
  const scheduleItemIndex = useRef(0);
  const [isItemLive, setIsItemLive] = useState(false);
  const [viewAllUrl, setViewAllUrl] = useState("");
  const [currentSeasonIndex, setCurrentSeasonIndex] = useState(null);
  const [showWaysToWatch, setShowWaysToWatch] = useState(false);
  const [svodWatchOptions, setSvodWatchOptions] = useState(null);
  const [filteredRecordings, setFilteredRecordings] = useState([]);
  const [showMoreInformationModal, setShowMoreInformationModal] = useState(false);
  const [isSubscribeEpisodeSet, setIsSubscribeEpisodeSet] = useState(false);
  const [isUnSubscribeEpisodeSet, setIsUnSubscribeEpisodeSet] = useState(false);
  const setTeamRecordingResponse = useSelector((state) => state?.recording?.setTeamRecordingResponse);
  const hasAllRecordingFetched = useRef(false);

  const match = useRouteMatch();
  const { t: translate } = useTranslation();
  const { isAppLanguageFrench } = useAppLanguage();
  const location = useLocation();
  const has4K = useRef(false);

  const history = useHistory();

  const { performPlaybackChecks } = usePlaybackChecks();
  const {
    params: { uriType, uriSubType, itemType, contentId },
  } = match;
  const isTeamsPage = itemType.toLowerCase() === CONTENT_ITEM_TYPES.team;
  const isSportSeries = itemType === PAGE_CONTENT_ITEM_TYPES.sportsSeries;
  const { contentMetadata, isUnifiedAsset } = useDetailsPageCompositor(
    CONTENT_ITEM_TYPES.series,
    isTeamsPage,
    isSportSeries
  );
  const liveGamesList = [];
  const uaGamesList = {};
  const THIRTY_HOURS_AGO = moment().subtract(30, "hours");
  const today = moment().format("YYYY-MM-DD");

  if (isSportSeries && listOfLiveGames?.length > 0) {
    for (const liveGame of listOfLiveGames) {
      const airingStartTime = liveGame?.metadata?.airingStartTime;
      const airingMoment = airingStartTime && moment(airingStartTime);
      if (!airingMoment) continue;

      const airingDate = airingMoment.format("YYYY-MM-DD");

      // Exclude past 30h (non-today) when lookback is disabled
      if (!isLookbackEnabled && airingMoment.isBetween(THIRTY_HOURS_AGO, moment()) && airingDate !== today) {
        continue;
      }

      const timeStampDate = airingMoment.format("ddd, MMM DD");
      liveGamesList.push({ ...liveGame, timeStampDate });
    }
  }
  for (let i = 0; i < liveGamesList.length; i++) {
    const game = liveGamesList[i];
    const timeStampDate = game.timeStampDate;
    if (uaGamesList[timeStampDate] == null) uaGamesList[timeStampDate] = [];
    uaGamesList[timeStampDate].push(game);
  }
  const modifiedGamesList = Object.keys(uaGamesList).map((timeStampDate) => {
    const currentDate = moment().format("ddd, MMM DD");
    let day;
    if (timeStampDate === currentDate) {
      day = translate("today");
    } else if (timeStampDate === moment().add(1, "d").format("ddd, MMM DD")) {
      day = translate("tomorrow");
    } else if (timeStampDate === moment().subtract(1, "d").format("ddd, MMM DD")) {
      if (!isLookbackEnabled) return null;
      day = translate("yesterday");
    } else {
      day = timeStampDate;
    }
    return {
      metadata: { season: day, episodeCount: uaGamesList[timeStampDate]?.length },
      games: uaGamesList[timeStampDate],
    };
  });
  const airingTodayIndex =
    modifiedGamesList?.length > 0 && modifiedGamesList.findIndex((game) => game.metadata.season === translate("today"));
  let liveUAEpisodes;
  if (isTeamsPage) {
    liveUAEpisodes = listOfLiveGames;
  } else if (isSportSeries) {
    liveUAEpisodes = listOfLiveGames?.length <= 20 ? listOfLiveGames : modifiedGamesList[currentSeasonIndex]?.games;
  } else {
    liveUAEpisodes = seasonEntitlements;
  }

  const convivaContSubType = useRef(useConvivaContentSubType(setConvivaContentSubType));
  const query = new URLSearchParams(location.search);
  const seasonIndex = query.get("index") ? query.get("index") : airingTodayIndex ? airingTodayIndex : 0;
  const [liveSchedule, setLiveSchedule] = useState(null);
  const [selectedAssetRecordingInfo, setSelectedAssetRecordingInfo] = useState(null);
  const [recordingActionError, setRecordingActionError] = useState(null);
  const isRecordingActionInProgress = useRef(false);
  const isTeamRecordingActionInProgress = useRef(false);
  const recordingEventTypeRef = useRef(null);
  const recordingEventCallbackFuncRef = useRef(null);
  const areGenreBasedSimilarItemsFetched = useRef(false); // ref to check if call was made to fetch similar items using client(genre-based) logic
  const isLiveProgramOOH = useRef(false); // ref to check for OOH restricted live program for primary(watch live) CTA
  const [entitlementSeason, setEntitlementSeason] = useState(null);
  const isAPIcallFired = useRef(false);

  const cancelTokenSource = useCancelTokenSource(); // cancelTokenSource ref for requests unmount clean up
  const { trackPageView, resetIsPageViewTracked } = useTrackPageView();

  const detailUri = `/${uriType}/${uriSubType}/${itemType}/${contentId}${isTeamsPage ? location.search : ""}`;
  const isUserLoggedIn = userProfile?.isLoggedIn ? true : false;
  const recordingSystemType = useMemo(
    () => (userProfile?.isLoggedIn ? getRecordingSystemType(userProfile) : null),
    [userProfile]
  );
  const lookbackProgram = useMemo(() => {
    return (
      (isLookbackEnabled &&
        getNewestLookbackProgram(schedules, subscribedChannels, isInHome, appProvider.channelMapID)) ||
      null
    );
  }, [isInHome, isLookbackEnabled, schedules, subscribedChannels, appProvider]);
  const lookbackHoursLeft = useMemo(
    () => (lookbackProgram ? calculateLookbackHoursLeft(lookbackProgram) : 0),
    [lookbackProgram]
  );

  /** isMR - type: boolean - check if a login user has Media Room recording package, this constant is crucial for recording functions*/
  const isMR = recordingSystemType === RECORDING_PACKAGES.PACKAGE_NAME.LPVRMediaroom_TP;

  const pcLevel = useMemo(
    () => getPcLevelRestriction(userProfile, isUserProfilesEnabled, isParentalPINEnabled),
    [isParentalPINEnabled, isUserProfilesEnabled, userProfile]
  );

  /**
   * Triggers a recording analytics event based on a toast message passed
   * @param {String} toastMsg
   */
  const triggerRecordingAnalyticsEvent = useCallback(
    (toastMsg) => {
      if (recordingEventTypeRef.current) {
        if (toastMsg === translate(RECORDING_PARAMS.SERIES_RECORDING_SET)) {
          trackGenericAction(
            recordingEventTypeRef.current,
            {
              isItemLive: true,
              isSeriesEvent: true,
              ...mapRecordingSeriesMediaContent(selectedAssetRecordingInfo?.assetToRecord),
            },
            isDynatraceTrackingEnabled
          );
        } else if (toastMsg === translate("team_recording_set")) {
          trackGenericAction(
            recordingEventTypeRef.current,
            {
              isItemLive: true,
              isTeamRecording: true,
              // Sport name lives on the episode's sports metadata, not on the series-level contentMetadata
              teamSport:
                selectedAssetRecordingInfo?.assetToRecord?.metadata?.extendedMetadata?.dlum?.sports?.name ||
                contentMetadata?.metadata?.seriesTitle,
              teamName: contentMetadata?.title || contentMetadata?.metadata?.title,
              ...mapRecordingSeriesMediaContent(selectedAssetRecordingInfo?.assetToRecord),
            },
            isDynatraceTrackingEnabled
          );
        } else if (toastMsg === translate(RECORDING_PARAMS.TEAM_RECORDING_CANCELLED)) {
          trackGenericAction(
            recordingEventTypeRef.current,
            {
              isItemLive: true,
              isTeamRecording: true,
              // Sport name lives on the episode's sports metadata, not on the series-level contentMetadata
              teamSport:
                selectedAssetRecordingInfo?.assetToRecord?.metadata?.extendedMetadata?.dlum?.sports?.name ||
                contentMetadata?.metadata?.seriesTitle,
              teamName: contentMetadata?.title || contentMetadata?.metadata?.title,
              ...mapRecordingSeriesMediaContent(selectedAssetRecordingInfo?.assetToRecord),
            },
            isDynatraceTrackingEnabled
          );
        } else if (toastMsg === translate(RECORDING_PARAMS.SERIES_RECORDING_UPDATED)) {
          recordingEventCallbackFuncRef.current();
        } else {
          trackRecordingError(
            recordingEventTypeRef.current,
            toastMsg,
            {
              errorCode: setRecordingResponse?.code,
              errorMessage: setRecordingResponse?.message,
            },
            isDynatraceTrackingEnabled
          );
        }
      }
    },
    [selectedAssetRecordingInfo, setRecordingResponse, translate, isDynatraceTrackingEnabled, contentMetadata]
  );

  /**
   * A callback function which will be triggered after a recording has been updated
   * @param {Boolean} isItemLive
   * @param {Boolean} isSeriesEvent
   * @param {String} mappedContentType live|svod|tvod|cpvr|lpvr
   * @param {String} analyticsEventType analytics event type
   * @param {String} toolSelections a toolSelection string with format: 'key:{selection},key:{selection}...'
   * @param {Object} error an error object
   */
  const trackRecordingUpdateEventCallback = useCallback(
    ({ isItemLive, isSeriesEvent, isTeamRecording, mappedContentType, analyticsEventType, toolSelections, error }) => {
      if (error) {
        // Triggers a stop|delete recording error.
        // The error of start a recording event comes from setRecordingResponse data which is handled via useEffect.
        trackRecordingError(
          analyticsEventType,
          error?.message,
          {
            errorCode: error?.code,
          },
          isDynatraceTrackingEnabled
        );
      } else {
        recordingEventCallbackFuncRef.current = () =>
          trackGenericAction(
            analyticsEventType,
            {
              isItemLive,
              isSeriesEvent,
              isTeamRecording,
              toolSelections,
              mappedContentType,
              ...(isTeamRecording
                ? {
                    // Sport name lives on the episode's sports metadata, not on the series-level contentMetadata
                    teamSport:
                      selectedAssetRecordingInfo?.assetToRecord?.metadata?.extendedMetadata?.dlum?.sports?.name ||
                      contentMetadata?.metadata?.seriesTitle,
                    teamName: contentMetadata?.title || contentMetadata?.metadata?.title,
                  }
                : {}),
              ...mapRecordingSeriesMediaContent(selectedAssetRecordingInfo?.assetToRecord),
            },
            isDynatraceTrackingEnabled
          );

        // The result of stop|delete a recording is ready at this moment
        if (
          analyticsEventType !== ANALYTICS_EVENT_TYPES.VIDEO_RECORD_SERIES_EDIT_COMPLETE &&
          analyticsEventType !== ANALYTICS_EVENT_TYPES.VIDEO_RECORD_TEAM_EDIT_COMPLETE
        ) {
          recordingEventCallbackFuncRef.current();
        } else {
          // At this moment, the result of editing a recording is unknown, but a toastMessage will show up on the screen according to the result of editing a recording.
          // Thus set the recordingEventType here, and then trigger the event based on the toastMessage later.
          recordingEventTypeRef.current = analyticsEventType;
        }
      }
    },
    [selectedAssetRecordingInfo, isDynatraceTrackingEnabled, contentMetadata]
  );

  useEffect(() => {
    if (priorityEpisode) convivaContSubType.current.updateContSubTypeViaPriorityEpisode(priorityEpisode);
  }, [priorityEpisode]);

  // Reset the recordings params associated with an outgoing recording manipulation action (set, edit, delete)
  const resetManipulatedRecordingParams = useCallback(() => {
    resetAction(MANIPULATE_RECORDING_ACTION_TRIGGERED, "recordingParams");
  }, [resetAction]);

  // Reset the response data from setting a recording
  const resetSetRecordingResponse = useCallback(() => {
    resetAction(SET_RECORDINGS, "content");
  }, [resetAction]);

  // Reset the response data from setting a recording
  const resetSetTeamRecordingResponse = useCallback(() => {
    resetAction(SET_TEAM_RECORDINGS, "content");
  }, [resetAction]);

  // Reset the response error from fetching recordings
  const resetGetRecordingError = useCallback(() => {
    resetAction(GET_RECORDINGS, "error");
  }, [resetAction]);

  // Reset the response data from editing a recording
  const resetEditRecordingResponse = useCallback(() => {
    resetAction(EDIT_RECORDINGS, "content");
  }, [resetAction]);

  // Reset the response data from deleting a recording
  const resetDeleteRecordingResponse = useCallback(() => {
    resetAction(DELETE_RECORDINGS, "content");
  }, [resetAction]);

  /**
   * Resets the values used to support recording CRUD action flows
   */
  const resetRecordingActionValues = useCallback(() => {
    isRecordingActionInProgress.current = false;
    isTeamRecordingActionInProgress.current = false;
    resetSetRecordingResponse();
    resetSetTeamRecordingResponse();
    resetEditRecordingResponse();
    resetDeleteRecordingResponse();
    resetManipulatedRecordingParams();
    resetGetRecordingError();
    setRecordingActionError(null);
  }, [
    resetDeleteRecordingResponse,
    resetEditRecordingResponse,
    resetGetRecordingError,
    resetManipulatedRecordingParams,
    resetSetRecordingResponse,
    resetSetTeamRecordingResponse,
  ]);

  useEffect(() => {
    return () => {
      setCurrentSeasonIndex(null);
      setPriorityEpisode(null);
      setIsItemLive(false);
      liveItem.current = 0;
      setViewAllUrl("");
      resetAction(LOAD_SERIES_PAGE_CONTAINERS, "content");
      resetAction(LOAD_SERIES_DETAIL, "content");
      resetAction(LOAD_SIMILAR_SERIES, "content");
      resetAction(ADD_FAVOURITE, "content");
      resetAction(DELETE_FAVOURITE, "content");
      resetAction(LOAD_SERIES_SCHEDULES, "content");
      resetAction(LOAD_CONTENT_USERDATA, "content");
      resetAction(LOAD_SEASON_DATA, "content");
      resetAction(LOAD_SEASON_ENTITLEMENTS, "content");
      resetAction(LOAD_LIST_OF_TEAMS, "content");
      resetAction(LOAD_RECENT_AIRINGS, "content");
      resetAction(LOAD_LIST_OF_GAMES, "content");
      areGenreBasedSimilarItemsFetched.current = false; // re-setting on change of content
      resetRecordingActionValues();
    };
  }, [contentId, resetAction, resetRecordingActionValues]);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadTVShowDetailItems(appProvider, detailUri, CONTAINER_TYPES.CONTAINERS);
  }, [appProvider, detailUri, loadTVShowDetailItems]);

  useEffect(() => {
    if (contentMetadata) {
      isUnifiedAsset
        ? loadSeasons(contentMetadata.containers)
        : loadSchedules(appProvider, contentMetadata.metadata?.title, cancelTokenSource);

      if (!isRecommendationMLTEnabled && contentMetadata.metadata?.extendedMetadata?.dlum?.displayGenres?.length > 0) {
        loadSimilarItems(
          appProvider,
          contentMetadata.metadata.contentType?.toLowerCase(),
          contentMetadata.metadata.extendedMetadata.dlum.displayGenres[0],
          contentMetadata.metadata.contentSubtype || CONTENT_ITEM_TYPES.series,
          userProfile,
          pcLevel,
          cancelTokenSource
        );
      }

      // TODO: Check if we need this call for teams page while working on live game ticket(TCDWC-3865)
      !isTeamsPage &&
        loadContentUserData(
          appProvider,
          isSportSeries ? contentMetadata.metadata?.seriesUaId : contentMetadata.id,
          PAGE_CONTENT_ITEM_TYPES.tvShow
        );
    }
  }, [
    appProvider,
    cancelTokenSource,
    isRecommendationMLTEnabled,
    isUnifiedAsset,
    loadContentUserData,
    loadSchedules,
    loadSeasons,
    loadSimilarItems,
    pcLevel,
    contentMetadata,
    userProfile,
    isTeamsPage,
    isSportSeries,
  ]);

  useEffect(() => {
    if (appProvider && contentMetadata?.metadata) {
      setDTPageAttributes({ [DT_ATTRIBUTES.SERIES_NAME]: contentMetadata.metadata.title }, isDynatraceTrackingEnabled);

      const assetDetails = { ...contentMetadata };

      // Add TAMS ID from priority episode
      if (assetDetails.metadata && !assetDetails.metadata.externalId && priorityEpisode) {
        assetDetails.metadata.externalId = priorityEpisode.metadata?.externalId;
      }
      const priorityLiveProgram = lookbackProgram || liveSchedule;

      if (
        isTeamsPage ||
        contentMetadata.metadata.contentId ||
        liveItem.current?.id ||
        priorityEpisode?.metadata?.contentId
      ) {
        const pageViewParams = {
          pageName: contentMetadata.metadata.title,
          contentId:
            contentMetadata.metadata.contentId ||
            liveItem.current?.id ||
            priorityEpisode?.metadata?.contentId ||
            contentId,
          productId: contentMetadata.metadata.extendedMetadata?.dlum?.umId,
          extraMetadataList: [
            {
              type: EXTRA_METADATA_TYPES.MEDIA_CONTENT,
              asset: {
                isItemLive,
                ...assetDetails,
                channel: {
                  channelId: priorityLiveProgram?.channel?.channelId,
                  channelNumber: getRegionalChannelNumber(priorityLiveProgram?.channel, appProvider?.channelMapID),
                },
                mappedContentType: priorityEpisode ? MAPPED_CONTENT_TYPES.SVOD : MAPPED_CONTENT_TYPES.TVOD,
              },
            },
            { type: EXTRA_METADATA_TYPES.COMMERCE },
            ...(getSessionStorage(ANALYTICS_STORAGE_KEYS.SEARCH_TERM)
              ? [{ type: EXTRA_METADATA_TYPES.SEARCH_CLICK }]
              : []),
          ],
        };

        // For teams pages, use web/telustv/team/{sport}/{team} as the page name
        if (isTeamsPage) {
          const sport = formatTrackingValue(contentMetadata.metadata.seriesTitle || "");
          const team = formatTrackingValue(contentMetadata.title || contentMetadata.metadata.title || "");
          pageViewParams.pageHierarchy = ["team", sport, team].filter(Boolean);
          pageViewParams.pageNameOverride = `web/${SITE_NAMES.TELUS_TV}/${["team", sport, team]
            .filter(Boolean)
            .join("/")}`;
        }

        trackPageView(pageViewParams);
      }
    }
  }, [
    trackPageView,
    contentMetadata,
    liveSchedule,
    appProvider,
    priorityEpisode,
    isItemLive,
    lookbackProgram,
    isDynatraceTrackingEnabled,
    isTeamsPage,
    contentId,
  ]);

  useEffect(() => {
    return () => {
      resetIsPageViewTracked();
    };
  }, [contentMetadata, resetIsPageViewTracked]);

  useEffect(() => {
    if (similarItems && contentMetadata?.metadata?.extendedMetadata?.dlum?.displayGenres?.length > 0) {
      setViewAllUrl(
        `${SIMILAR_ITEMS.route}/${contentMetadata.id}` +
          `?itemType=${CONTENT_ITEM_TYPES.series}` +
          `&genres=${contentMetadata.metadata.extendedMetadata.dlum.displayGenres[0]}` +
          `&itemSubType=${contentMetadata.metadata.contentSubtype ?? CONTENT_ITEM_TYPES.series}`
      );
    }
    if (
      contentMetadata?.metadata?.extendedMetadata?.dlum?.displayGenres?.length > 0 &&
      !areGenreBasedSimilarItemsFetched.current && // check to make api call only if not made before, to avoid loop in case of genre-based api failure
      isRecommendationMLTEnabled &&
      similarItems?.length === 0 // similarItems is an empty array in case of api failure, so this checks if the recommendation API failed or returned empty
    ) {
      areGenreBasedSimilarItemsFetched.current = true;
      loadSimilarItems(
        appProvider,
        contentMetadata.metadata?.contentType?.toLowerCase(),
        contentMetadata?.metadata?.extendedMetadata?.dlum?.displayGenres[0],
        contentMetadata.metadata?.contentSubtype || CONTENT_ITEM_TYPES.series,
        userProfile,
        pcLevel,
        cancelTokenSource
      );
    }
  }, [
    contentMetadata,
    similarItems,
    isRecommendationMLTEnabled,
    loadSimilarItems,
    appProvider,
    pcLevel,
    cancelTokenSource,
    userProfile,
  ]);

  useEffect(() => {
    if (userProfile?.isLoggedIn) {
      if (!subscribedChannels && appProvider)
        loadUserSubscribedChannels(appProvider, userProfile, cancelTokenSource, isUserProfilesEnabled);
    }
  }, [
    appProvider,
    cancelTokenSource,
    loadUserSubscribedChannels,
    subscribedChannels,
    userProfile,
    isUserProfilesEnabled,
  ]);

  const currentAndUpcomingSchedules = useMemo(() => {
    if (!isTeamsPage && schedules?.length) {
      const currentTime = moment().valueOf();
      return schedules.filter((schedule) => {
        return schedule.metadata.airingEndTime >= currentTime;
      });
    }
  }, [schedules, isTeamsPage]);

  /** we need to create a recordable program list from live and upcoming schedules, this list can be used on recording functions */
  const recordablePrograms = useMemo(() => {
    if (isRecordingEnabled && currentAndUpcomingSchedules && subscribedChannels) {
      return getRecordablePrograms(currentAndUpcomingSchedules, subscribedChannels);
    }
  }, [isRecordingEnabled, currentAndUpcomingSchedules, subscribedChannels]);

  // list of recording info objects for every program schedule that the user is subscribed to and is airing on a recordable channel
  const programsRecordingInfoList = useMemo(() => {
    if (recordingsList && recordablePrograms) {
      return recordablePrograms.map((schedule) => {
        return getRecordingInfo(isMR, schedule, recordingsList, appProvider?.channelMapID);
      });
    }

    return null;
  }, [recordingsList, isMR, recordablePrograms, appProvider]);

  useEffect(() => {
    if (!recordingsList) return;
    const filterContainers = (recording) => {
      const container = recording?.containers ? recording.containers : recording?.recordings;
      return container.filter((container) => {
        const extendedMetadata = container?.metadata?.extendedMetadata?.dlum;
        const recordingStatus = getCPVRRecordingStatus({ eventRecordingItem: container });

        if (!(isCPVRRecordingRecorded(recordingStatus) || isCPVRRecordingInProgress(recordingStatus))) {
          return false;
        }

        if (isSportSeries) {
          return extendedMetadata?.uaGroupId === contentMetadata?.metadata?.seriesUaId;
        }
        if (isTeamsPage) {
          const sports = extendedMetadata?.sports;
          return (
            sports?.homeUmId === contentMetadata?.metadata?.teamUmId ||
            sports?.guestUmId === contentMetadata?.metadata?.teamUmId
          );
        }
        return false;
      });
    };

    const filtered = recordingsList.flatMap(filterContainers);

    // Enrich each filtered item with recordingData
    const enrichedFiltered = filtered.map((enrichedItem) => {
      return {
        ...enrichedItem,
        recordingData: {
          isMR,
          recordingInfo: getRecordingInfo(isMR, enrichedItem, recordingsList, appProvider?.channelMapID),
        },
      };
    });

    const sortedFiltered = enrichedFiltered.sort((a, b) => {
      const timeA = new Date(a?.metadata?.recordingStartTime).getTime();
      const timeB = new Date(b?.metadata?.recordingStartTime).getTime();
      return timeB - timeA;
    });

    setFilteredRecordings(sortedFiltered);
  }, [
    recordingsList,
    contentMetadata,
    isSportSeries,
    isTeamsPage,
    setFilteredRecordings,
    appProvider.channelMapID,
    isMR,
  ]);

  const getRecentRecordingItems = () => {
    const recordingsContainer =
      seriesContainers?.length > 0 && findContainerByLayout(seriesContainers, CONTAINER_LAYOUTS.RECENT_RECORDINGS);
    const title = recordingsContainer?.title;
    return createSwimlaneModels({
      data: filteredRecordings.length > 20 ? filteredRecordings.slice(0, 20) : filteredRecordings,
      avsComponent: { metadata: { label: title } },
      addParams: {
        DIMENSIONS: ITEM_TYPES.TITLE_ITEM.LANDSCAPE.DIMENSIONS,
        viewAllUrl: filteredRecordings.length > 20 ? getRouteToPVRManager() : null,
      },
      itemsCount: filteredRecordings.length,
      isAppLanguageFrench,
      userProfile,
      isCPVRBookmarksEnabled,
    });
  };

  // Recording info that is associated with the primary recording button
  const primaryRecordingInfo = useMemo(() => {
    if (programsRecordingInfoList) {
      if (isMR) {
        return programsRecordingInfoList.find((program) => !program.recordingEventScheduledCheck);
      } else {
        // Find the first schedule that has a recording associated with it already
        const firstExistingRecordingAsset = programsRecordingInfoList.find((recordingInfo) => {
          const assetRecordingStatus = getCPVRRecordingStatus(recordingInfo, true);
          return (
            !doesCPVREventRecordingExist(assetRecordingStatus) && doesCPVRSeriesRecordingExist(assetRecordingStatus)
          );
        });

        return firstExistingRecordingAsset || programsRecordingInfoList[0];
      }
    }

    return null;
  }, [isMR, programsRecordingInfoList]);

  // Primary recording button CTA details
  const primaryRecordingCTA = useMemo(() => {
    if (primaryRecordingInfo) {
      if (isMR) {
        let isSeriesRecordingSet = false;
        if (primaryRecordingInfo.recordingSeriesScheduledCheck) {
          isSeriesRecordingSet = true;
        }

        return getRecordingCTAs(
          true,
          primaryRecordingInfo,
          recordablePrograms,
          false,
          false,
          primaryRecordingInfo.recordingSeriesConflictCheck,
          isSeriesRecordingSet,
          true
        );
      } else {
        return getRecordingCTAs(false, primaryRecordingInfo, recordablePrograms, false, false, false, false, true);
      }
    }
    return null;
  }, [isMR, primaryRecordingInfo, recordablePrograms]);

  // Primary team recording button CTA details
  const primaryTeamsRecordingCTA = useMemo(() => {
    if (isTeamRecordingsEnabled && isTeamsPage && recordingSystemType) {
      const teamUmId = contentMetadata?.metadata?.teamUmId;
      const seriesRecordingsList = getSeriesRecordings(recordingsList);
      const recordingParams = getTeamRecordingParams(teamUmId, seriesRecordingsList);
      return recordingParams ? recordingParams : null;
    }
    return null;
  }, [contentMetadata, isTeamsPage, recordingsList, isTeamRecordingsEnabled, recordingSystemType]);

  /**
   * Determines the appropriate recording toast message to display
   *
   * @param {Object} recordingInfo - recording information used to determine the toast message
   * @param {String} actionType - type of recording action that occurred (set/edit/delete)
   * @returns {String} recordings-specific toast message
   */
  const getRecordingToastMessage = useCallback(
    (recordingInfo, actionType) => {
      let toastMsg;
      const teamsRecordingsCheck = isTeamRecordingsEnabled && isTeamsPage;
      if (recordingInfo.code) {
        //It is yet to be decided what needs to be displayed when there is an error on the team recording action.
        if (actionType === "set") {
          toastMsg = teamsRecordingsCheck
            ? RECORDING_PARAMS.TEAM_RECORDING_NOT_SET
            : translate(RECORDING_PARAMS.RECORDING_NOT_SET);
        } else if (actionType === "edit") {
          toastMsg = translate(RECORDING_PARAMS["SERIES_RECORDING_NOT_UPDATED"]);
        } else if (actionType === "delete") {
          toastMsg = teamsRecordingsCheck
            ? translate(RECORDING_PARAMS.TEAM_CANNOT_BE_CANCELED)
            : translate(RECORDING_PARAMS.COULD_NOT_CANCEL_RECORDING);
        }
      } else {
        if (actionType === "set") {
          toastMsg = teamsRecordingsCheck
            ? translate("team_recording_set")
            : translate(RECORDING_PARAMS["SERIES_RECORDING_SET"]);
        } else if (actionType === "edit") {
          toastMsg = translate(RECORDING_PARAMS["SERIES_RECORDING_UPDATED"]);
        } else if (actionType === "delete") {
          toastMsg = teamsRecordingsCheck
            ? translate(RECORDING_PARAMS.TEAM_RECORDING_CANCELLED)
            : translate(RECORDING_PARAMS["SERIES_RECORDING_CANCELLED"]);
        }
      }
      triggerRecordingAnalyticsEvent(toastMsg);

      return toastMsg;
    },
    [translate, triggerRecordingAnalyticsEvent, isTeamsPage, isTeamRecordingsEnabled]
  );

  /**
   * Displays the appropriate recording toast message (if any)
   *
   * @param {Object} recordingInfo - recording information used to determine the toast message
   * @param {Object} manipulatedRecordingParams - refer to manipulateActionTriggered() in RecordingsPage/state/actions.js
   */
  const displayRecordingToast = useCallback(
    (recordingInfo, manipulatedRecordingParams) => {
      if (recordingInfo && manipulatedRecordingParams) {
        const toastMsg = getRecordingToastMessage(recordingInfo, manipulatedRecordingParams.actionType);
        if (toastMsg) {
          showToastNotification(toastMsg);
          recordingEventTypeRef.current = null;
        }
      }
    },
    [getRecordingToastMessage, showToastNotification]
  );

  // Used to display the loading spinner on the primary recording button, as appropriate
  const showRecordingCTALoading =
    manipulatedRecordingParams &&
    primaryRecordingInfo &&
    manipulatedRecordingParams.targetAssetInfo.id === primaryRecordingInfo.assetToRecord.id;

  /**
   * Fetch the user's recordings and save the response in redux
   *
   * @param {Object} recordingParamsMR - MR specific recording params used for set/edit/delete recording when initial attempt reports PENDING status
   * @param {Boolean} fetchingAfterAction - flag used to differentiate between initial fetch and post-action fetches
   */
  const fetchRecordings = useCallback(
    async (recordingParamsMR = null) => {
      if (isTeamRecordingsEnabled && isTeamsPage) {
        if (isTeamRecordingActionInProgress.current) return;
      } else {
        if (isRecordingActionInProgress.current) return;
      }

      if (isTeamRecordingsEnabled && isTeamsPage) {
        isTeamRecordingActionInProgress.current = true;
      } else {
        isRecordingActionInProgress.current = true;
      }

      let recordingsResponse;
      if (isMR) {
        // Media Room specific call
        recordingsResponse = await getRecordingAction(
          appProvider,
          true,
          null,
          null,
          null,
          MR_RECORDING_FILTER_OPTIONS.SCHEDULED_PAGE_FILTERS,
          recordingParamsMR
        );
      } else {
        recordingsResponse = await getRecordingAction(appProvider, false, true, null, [
          RECORDING_PARAMS.EVENT,
          RECORDING_PARAMS.SERIES,
        ]);
      }

      // After fetch completes, reset the in-progress flag
      if (isTeamRecordingsEnabled && isTeamsPage && recordingsResponse) {
        displayRecordingToast(setTeamRecordingResponse || deleteRecordingResponse, manipulatedRecordingParams);
        resetManipulatedRecordingParams();
        isTeamRecordingActionInProgress.current = false;
        hasAllRecordingFetched.current = false;
        resetDeleteRecordingResponse();
      }
    },
    [
      isTeamRecordingsEnabled,
      isTeamsPage,
      isMR,
      getRecordingAction,
      appProvider,
      displayRecordingToast,
      setTeamRecordingResponse,
      manipulatedRecordingParams,
      resetManipulatedRecordingParams,
      deleteRecordingResponse,
      resetDeleteRecordingResponse,
    ]
  );

  /**
   * This useEffect is used to deal with errors that occur during recording CRUD actions
   */
  useEffect(() => {
    if ((getRecordingError || recordingActionError) && manipulatedRecordingParams) {
      displayRecordingToast(getRecordingError || recordingActionError, manipulatedRecordingParams);
      resetRecordingActionValues();
    }
  }, [
    displayRecordingToast,
    getRecordingError,
    manipulatedRecordingParams,
    recordingActionError,
    resetRecordingActionValues,
  ]);

  /**
   * This useEffect is used after we have re-fetched recordings following a set/edit/delete recording action.
   */
  useEffect(() => {
    if (programsRecordingInfoList && manipulatedRecordingParams && isRecordingActionInProgress.current) {
      const selectedRecordingInfo = programsRecordingInfoList.find((recordingInfo) => {
        return recordingInfo?.assetToRecord?.id === selectedAssetRecordingInfo?.assetToRecord?.id;
      });
      // Can't use the selectedAssetRecordingInfo as-is, need to update it with the latest recording state checks/values
      setSelectedAssetRecordingInfo(selectedRecordingInfo);
      if (selectedRecordingInfo) {
        if (isMR && selectedRecordingInfo.recordingSeriesConflictCheck) {
          setShowRecordingModal(true);
        } else {
          displayRecordingToast(selectedRecordingInfo, manipulatedRecordingParams);
        }
      }

      resetRecordingActionValues();
    }
  }, [
    displayRecordingToast,
    programsRecordingInfoList,
    isMR,
    manipulatedRecordingParams,
    resetRecordingActionValues,
    selectedAssetRecordingInfo,
    setTeamRecordingResponse,
    isTeamsPage,
    isTeamRecordingsEnabled,
    loadComponent,
  ]);

  const handleRecordingResponse = useCallback(
    (response, isTeamAction) => {
      if (!response) return;

      if (isMR) {
        if (response.code) {
          // Error occurred on MR
          setRecordingActionError(response);
        } else {
          fetchRecordings(isRecordingPendingStateCheck(response.content) ? response.recordingParams : null);
        }
      } else {
        if (response.code) {
          if (checkCPVRConflicts(response)) {
            // show popup modal for recording conflict error
            showCPVRConflictModal(
              () => {
                navigateToPVRManager(true);
                setSessionStorage(
                  ANALYTICS_STORAGE_KEYS.LINK,
                  `${LINK_INFO.MANAGE_RECORDINGS};${LINK_INFO.RECORDING_PROMPT}`
                );
              },
              () => {
                //It is yet to be decided what needs to be displayed when there is an error on the team recording action.
                const toastMessage =
                  isTeamRecordingsEnabled && isTeamAction
                    ? RECORDING_PARAMS.TEAM_RECORDING_NOT_SET
                    : translate("recording_not_set");
                showToastNotification(toastMessage);
              },
              MODAL_TYPES.ERROR,
              showModalPopup
            );
            resetRecordingActionValues();
          } else {
            // show generic 'not set' toast notification for all other errors
            setRecordingActionError(response);
          }
        } else {
          // No error in the response, refresh our recordings list
          if (isTeamRecordingsEnabled && isTeamAction) {
            if (!hasAllRecordingFetched.current) {
              fetchRecordings(null);
              hasAllRecordingFetched.current = true;
            }
          } else {
            fetchRecordings(null);
          }
        }
      }
    },
    [
      isMR,
      fetchRecordings,
      showModalPopup,
      resetRecordingActionValues,
      isTeamRecordingsEnabled,
      translate,
      showToastNotification,
    ]
  );

  /**
   * This useEffect is used after we have attempted to schedule a recording
   */
  useEffect(() => {
    isRecordingActionInProgress.current = false;
    isTeamRecordingActionInProgress.current = false;
    if (
      (setRecordingResponse && isRecordingActionInProgress.current === false) ||
      (setTeamRecordingResponse && isTeamRecordingActionInProgress.current === false) ||
      (isTeamsPage && deleteRecordingResponse && isTeamRecordingActionInProgress.current === false)
    ) {
      if (isMR && setRecordingResponse) {
        handleRecordingResponse(setRecordingResponse, false);
      } else if (setRecordingResponse) {
        handleRecordingResponse(setRecordingResponse, false);
      } else if (setTeamRecordingResponse) {
        handleRecordingResponse(setTeamRecordingResponse, true);
      } else if (isTeamsPage && deleteRecordingResponse) {
        handleRecordingResponse(deleteRecordingResponse, true);
        hasAllRecordingFetched.current = true;
      }
    }
  }, [
    setRecordingResponse,
    setTeamRecordingResponse,
    isRecordingActionInProgress,
    isTeamRecordingActionInProgress,
    handleRecordingResponse,
    isMR,
    deleteRecordingResponse,
    isTeamsPage,
    hasAllRecordingFetched,
  ]);

  /**
   * This useEffect is used after we have attempted to edit a recording
   */
  useEffect(() => {
    if (editRecordingResponse && isRecordingActionInProgress.current === false) {
      if (editRecordingResponse.code) {
        // Error occurred
        setRecordingActionError(editRecordingResponse);
      } else {
        fetchRecordings(
          isMR && isRecordingPendingStateCheck(editRecordingResponse.content)
            ? editRecordingResponse.recordingParams
            : null
        );
      }
    }
  }, [editRecordingResponse, isMR, fetchRecordings]);

  /**
   * This useEffect is used after we have attempted to cancel a recording
   */
  useEffect(() => {
    if (deleteRecordingResponse && isRecordingActionInProgress.current === false && !isTeamsPage) {
      if (deleteRecordingResponse.code) {
        // Error occurred
        setRecordingActionError(deleteRecordingResponse);
      } else {
        // Nothing useful returned in the MR delete response, so we assume its pending
        fetchRecordings(isMR ? deleteRecordingResponse.recordingParams : null);
      }
    }
  }, [deleteRecordingResponse, fetchRecordings, isMR, isTeamsPage, isTeamRecordingsEnabled]);

  /**
   * Schedule a recording and save the response in redux
   *
   * @param {String} typeOfRecording - the recording type (SERIES)
   * @param {Object} recordingInfo - recording information used to set the recording
   */
  const scheduleRecording = useCallback(
    (typeOfRecording, recordingInfo) => {
      if (recordingInfo) {
        recordingEventTypeRef.current = ANALYTICS_EVENT_TYPES.VIDEO_RECORD_START;
        setRecording(typeOfRecording, appProvider, recordingInfo.assetToRecord, setRecordingAction, isMR);
      }
    },
    [appProvider, isMR, setRecordingAction]
  );

  /**
   * Displays the recording editing panel when the user tries to edit the recordings
   *
   * @param {Object} recordingInfo - recording information used to edit the recording
   * @param {String} typeOfRecording - the recording type (SERIES)
   */
  const showRecordingSettingHandler = useCallback(
    (recordingInfo, typeOfRecording) => {
      const isTeamRecording = typeOfRecording === RECORDING_PARAMS.TEAM;
      const getEditStartEventType = () => {
        if (isTeamRecording) return ANALYTICS_EVENT_TYPES.VIDEO_RECORD_TEAM_EDIT_START;
        return ANALYTICS_EVENT_TYPES.VIDEO_RECORD_SERIES_EDIT_START;
      };
      trackRecordingUpdateEventCallback({
        isItemLive: true,
        isSeriesEvent: !isTeamRecording,
        isTeamRecording,
        mappedContentType: MAPPED_CONTENT_TYPES.LIVE,
        analyticsEventType: getEditStartEventType(),
      });
      showRecordingSettingsPanel(
        typeOfRecording,
        recordingInfo,
        !isMR ? recordablePrograms : null,
        false,
        (recordingData) => trackRecordingUpdateEventCallback({ recordingInfo, ...recordingData })
      );
    },
    [recordablePrograms, showRecordingSettingsPanel, trackRecordingUpdateEventCallback, isMR]
  );

  /** Click event handler replaces the recording modal popup*/
  const handleRecordingAction = useCallback(
    (event, recordingInfo) => {
      event.stopPropagation();
      if (recordingInfo) {
        setSelectedAssetRecordingInfo(recordingInfo);
        if (isMR) {
          const hasSeriesRecording = recordingInfo.recordingSeriesScheduledCheck;
          const hasConflict = recordingInfo.recordingSeriesConflictCheck;
          if (hasConflict) {
            setShowRecordingModal(true);
          } else if (hasSeriesRecording) {
            showRecordingSettingHandler(recordingInfo, RECORDING_PARAMS.SERIES);
            toggleSettingsPanelAction(true);
          } else if (!recordingInfo.recordingSeriesConflictCheck && !recordingInfo.recordingSeriesScheduledCheck) {
            scheduleRecording(RECORDING_PARAMS.SERIES, recordingInfo);
          }
        } else {
          const cpvrRecordingExists = doesCPVRSeriesRecordingExist(getCPVRRecordingStatus(recordingInfo, true));
          if (cpvrRecordingExists) {
            // Show edit settings panel
            showRecordingSettingHandler(recordingInfo, RECORDING_PARAMS.SERIES);
            toggleSettingsPanelAction(true);
          } else {
            scheduleRecording(RECORDING_PARAMS.SERIES, recordingInfo);
          }
        }
      }
    },
    [isMR, showRecordingSettingHandler, toggleSettingsPanelAction, scheduleRecording]
  );

  const scheduleTeamRecording = useCallback(
    async (teamRecordingsParams) => {
      if (teamRecordingsParams) {
        const response = await dispatch(setTeamRecordingAction(appProvider, teamRecordingsParams));
        if (response) resetSetTeamRecordingResponse();
      }
    },
    [appProvider, dispatch, resetSetTeamRecordingResponse]
  );

  const handleTeamsRecordingAction = useCallback(
    (event, recordingInfo) => {
      event.stopPropagation();
      if (recordingInfo.recordingExists) {
        // Attach sport name so it's available downstream in CancelPopup
        recordingInfo.teamSport = contentMetadata?.metadata?.seriesTitle;
        // Show edit settings panel
        showRecordingSettingHandler(recordingInfo, RECORDING_PARAMS.TEAM);
        toggleSettingsPanelAction(true);
      } else {
        recordingEventTypeRef.current = ANALYTICS_EVENT_TYPES.VIDEO_RECORD_START;
        scheduleTeamRecording({
          filter: RECORDING_PARAMS.SPORTS_TEAM,
          filterBy: { teamUmId: contentMetadata?.metadata?.teamUmId },
        });
      }
    },
    [
      showRecordingSettingHandler,
      toggleSettingsPanelAction,
      scheduleTeamRecording,
      contentMetadata?.metadata?.teamUmId,
      contentMetadata?.metadata?.seriesTitle,
    ]
  );

  useEffect(() => {
    const fetchFirstPlayableEpisode = async (season) => {
      // Need to display the fist season's episode and function sorts in descending order
      const seasons = [...seasonData]?.sort(seasonCompareFunction);
      const firstSeason = seasons?.[seasons.length - 1];
      const isEntitlementCallNeeded = getCheckForEntitlementCall(season, firstSeason);

      const { firstPlayableEpisode, firstEpisode } =
        (seasonEntitlements &&
          (await getFirstPlayableEpisode(appProvider, firstSeason, seasonEntitlements, isEntitlementCallNeeded))) ||
        {};
      const hasUnSubscriptionAsset = firstEpisode?.userData?.entitlement?.assets.some(
        (asset) =>
          asset.assetType === ASSET_TYPES.MASTER.toUpperCase() &&
          asset.rights === WATCH_OPTIONS.buy &&
          asset.commercialPackages[0]?.type === "Subscription"
      );
      setIsUnSubscribeEpisodeSet(hasUnSubscriptionAsset);
      if (firstPlayableEpisode) {
        if (Array.isArray(firstPlayableEpisode)) {
          if (
            firstPlayableEpisode.length > 1 &&
            firstPlayableEpisode.every((episodeInfo) => !(episodeInfo.userData?.metadata?.bookmarks?.length > 0))
          ) {
            setSvodWatchOptions(firstPlayableEpisode); // displaying ways to watch prompt, in case multiple svod watch options are present and series is un-started
          }
          setPriorityEpisode(firstPlayableEpisode[0]); // giving priority to first available svod watch option
          setIsSubscribeEpisodeSet(true);
        } else {
          setPriorityEpisode(firstPlayableEpisode);
          setIsSubscribeEpisodeSet(true);
        }
      }
    };

    const fetchPlayableEpisode = async (bookmark, season, isEntitlementCallNeeded) => {
      const playableEpisodeInfo =
        seasonEntitlements &&
        (await getPlayableEpisode(appProvider, bookmark, season, seasonEntitlements, isEntitlementCallNeeded));
      if (!isSportSeries) {
        if (playableEpisodeInfo) {
          setIsSubscribeEpisodeSet(true);
          setPriorityEpisode(playableEpisodeInfo);
        } else {
          fetchFirstPlayableEpisode(season);
        }
      }
    };
    if ((contentUserData || appProvider.panicMode) && seasonData?.length > 0) {
      const bookmarks = contentUserData?.metadata?.bookmarks;
      const sortedBookmarks = bookmarks?.sort((previousBookmark, nextBookmark) => {
        return (
          parseInt(nextBookmark?.season) - parseInt(previousBookmark?.season) ||
          parseInt(nextBookmark?.episodeNumber) - parseInt(previousBookmark?.episodeNumber)
        );
      });
      const sortedSeasonData = seasonData.sort(seasonCompareFunction);
      const seasonDataSort = getSortedSeasons(contentMetadata, sortedSeasonData);
      let season;
      if (seasonIndex) {
        season = seasonDataSort[seasonIndex];
      } else {
        if (sortedBookmarks?.length > 0) {
          season = seasonDataSort.find((season) => {
            return parseInt(season?.metadata?.season) === parseInt(sortedBookmarks[0].season);
          });
        } else {
          season = seasonDataSort?.[seasonDataSort.length - 1];
        }
      }
      setCurrentSeasonIndex(seasonDataSort.findIndex((seasonData) => seasonData === season));
      setEntitlementSeason(season);

      if (!priorityEpisode) {
        const lastBookmark =
          sortedBookmarks?.find((bookmark) => {
            return parseInt(bookmark?.season) === parseInt(season?.metadata?.season);
          }) || sortedBookmarks?.[0];
        if (!isSportSeries) {
          if (lastBookmark) {
            const bookmarkedSeason = seasonDataSort.find((season) => {
              return parseInt(season?.metadata?.season) === parseInt(lastBookmark.season);
            });
            fetchPlayableEpisode(lastBookmark, bookmarkedSeason, getCheckForEntitlementCall(season, bookmarkedSeason));
          } else {
            fetchFirstPlayableEpisode(season);
          }
        }
      }
    }
    has4K.current = is4KChan(isLookbackEnabled ? schedules : currentAndUpcomingSchedules, channelMapInfo);
    if (isSportSeries) {
      setCurrentSeasonIndex(seasonIndex > 0 ? seasonIndex : 0);
    }
  }, [
    seasonData,
    isSportSeries,
    contentUserData,
    appProvider,
    seasonIndex,
    isUnifiedAsset,
    loadTVShowDetailItems,
    seasonEntitlements,
    priorityEpisode,
    contentMetadata,
    channelMapInfo,
    currentAndUpcomingSchedules,
    schedules,
    isLookbackEnabled,
    subscribedChannels,
  ]);

  useEffect(() => {
    if (entitlementSeason) {
      loadSeasonEntitlements(
        appProvider,
        `${entitlementSeason.id}?season=${entitlementSeason.metadata?.season}`,
        isUserLoggedIn
      );
    }

    return () => {
      resetAction(LOAD_SEASON_ENTITLEMENTS, "content");
    };
  }, [appProvider, loadSeasonEntitlements, resetAction, entitlementSeason, isUserLoggedIn]);

  const firstLiveOOHAsset = useRef(null);
  const contentMetadataId = contentMetadata?.id;

  useEffect(() => {
    const processScheduleItem = (currentTime, liveSchedules, nextIndex) => {
      const processNextScheduleItem = () => {
        scheduleItemIndex.current++;
        if (scheduleItemIndex.current < liveSchedules.length) {
          processScheduleItem(currentTime, liveSchedules, scheduleItemIndex.current);
        }
      };

      const schedule = liveSchedules[nextIndex];
      if (schedule?.metadata && schedule.channel) {
        const channelObj = getLiveChannelAsset(subscribedChannels?.containers, schedule.channel.channelId);
        const isLive =
          currentTime > schedule.metadata.airingStartTime &&
          currentTime < schedule.metadata.airingEndTime &&
          !isGhostChannel(channelObj);
        if (isLive) {
          !isItemLive && setIsItemLive(true);
          if (!channelObj?.metadata?.isNotAvailableOutOfHome) {
            // Checking first for in-home live schedule
            if (!liveItem.current) {
              liveItem.current = schedule;
            } else {
              processNextScheduleItem();
            }
          } else {
            if (!firstLiveOOHAsset.current) {
              firstLiveOOHAsset.current = schedule;
            }
            if (
              scheduleItemIndex.current === liveSchedules.length - 1 &&
              firstLiveOOHAsset.current &&
              !liveItem.current
            ) {
              liveItem.current = firstLiveOOHAsset.current; // Using the first out-of-home live schedule in case no in-home live schedules are present for live CTA
              isLiveProgramOOH.current = true;
            }
          }
          setLiveSchedule(schedule);
        } else {
          processNextScheduleItem();
        }
      } else {
        processNextScheduleItem();
      }
    };

    if (schedules?.length && contentMetadataId && !isItemLive) {
      const currentTime = moment().valueOf();
      // Filtering in the schedules which are currently live.
      const liveSchedules = schedules.filter(
        (schedule) => currentTime < schedule.metadata.airingEndTime && currentTime > schedule.metadata.airingStartTime
      );
      if (liveSchedules.length) {
        if (isUnifiedAsset) {
          processScheduleItem(currentTime, liveSchedules, scheduleItemIndex.current); // To be disable live CTA button for MVE1
        } else {
          const liveItemDetail = getItemLiveAvailability(liveSchedules, contentMetadataId, appProvider, currentTime);
          if (liveItemDetail) {
            setIsItemLive(true);
            if (!liveItem.current) {
              liveItem.current = liveItemDetail;
              if (liveItemDetail.isNotAvailableOutOfHome) isLiveProgramOOH.current = true;
            }
          }
        }
      }
    }
  }, [schedules, isUnifiedAsset, contentMetadataId, appProvider, isItemLive, subscribedChannels]);

  /**
   * Load channels data if it doesn't exist yet & user is logged in
   */
  useEffect(() => {
    if (isUserLoggedIn && !channelMapInfo && appProvider) {
      loadChannels(appProvider, cancelTokenSource);
    }
  }, [appProvider, channelMapInfo, isUserLoggedIn, loadChannels, cancelTokenSource]);

  const getEpisodeList = () => {
    let episodeItems = [];
    const showSeasonEpisodesForGuestUser = !isUserLoggedIn && seasonEntitlements?.length > 0;
    if ((schedules && subscribedChannels?.containers) || listOfLiveGames || showSeasonEpisodesForGuestUser) {
      episodeItems = createEpisodeSwimlaneItems(
        liveUAEpisodes,
        schedules,
        subscribedChannels,
        priorityEpisode?.userData?.entitlement?.isGeoBlocked,
        isInHome,
        isLookbackEnabled,
        appProvider.channelMapID,
        listOfLiveGames,
        showSeasonEpisodesForGuestUser
      );
    }

    return createSwimlaneFeedItem("", episodeItems);
  };

  const getRolesFeed = () => {
    const peopleList = contentMetadata.metadata.extendedMetadata.dlum.people;
    const title = translate(SWIMLANE_TITLES.CAST_AND_CREW);
    return createSwimlaneModels({
      data: peopleList.map((item) => ({ metadata: item })),
      avsComponent: { metadata: { label: title }, title },
      addParams: { DIMENSIONS: ITEM_TYPES.CHARACTER_ITEM.DIMENSIONS },
      itemsCount: peopleList.length,
      isAppLanguageFrench,
      userProfile,
    });
  };

  const addFavourite = () => {
    if (!isAPIcallFired.current) {
      isAPIcallFired.current = true;
      trackGenericAction(
        ANALYTICS_EVENT_TYPES.FAVOURITE,
        {
          ...contentMetadata,
          mappedContentType: priorityEpisode ? MAPPED_CONTENT_TYPES.SVOD : MAPPED_CONTENT_TYPES.TVOD,
        },
        isDynatraceTrackingEnabled
      );
      if (isConvivaAppTrackerEnabled) {
        trackConvivaCustomEvent(
          ANALYTICS_EVENT_TYPES.FAVOURITE,
          getCustomContextMetadata(contentMetadata, userProfile, appProvider, isInHome)
        );
      }
      addFavourites(appProvider, contentMetadata, PAGE_CONTENT_ITEM_TYPES.tvShow, isSportSeries);
    }
  };

  const removeFavourite = () => {
    if (!isAPIcallFired.current) {
      isAPIcallFired.current = true;
      trackGenericAction(
        ANALYTICS_EVENT_TYPES.UNFAVOURITE,
        {
          ...contentMetadata,
          mappedContentType: priorityEpisode ? MAPPED_CONTENT_TYPES.SVOD : MAPPED_CONTENT_TYPES.TVOD,
        },
        isDynatraceTrackingEnabled
      );
      if (isConvivaAppTrackerEnabled) {
        trackConvivaCustomEvent(
          ANALYTICS_EVENT_TYPES.UNFAVOURITE,
          getCustomContextMetadata(contentMetadata, userProfile, appProvider, isInHome)
        );
      }
      deleteFavourites(appProvider, contentMetadata, PAGE_CONTENT_ITEM_TYPES.tvShow, isSportSeries);
    }
  };

  const closeRecordingModal = () => {
    document.body.style.overflowY = "scroll";
    setShowRecordingModal(false);
  };

  const getRecordingButton = useCallback(() => {
    const recordingCTA =
      primaryRecordingCTA || (isTeamRecordingsEnabled && isTeamsPage ? primaryTeamsRecordingCTA : null);

    if (!recordingCTA) return null;

    const handleClick = primaryRecordingCTA
      ? (event) => handleRecordingAction(event, primaryRecordingInfo)
      : (event) => handleTeamsRecordingAction(event, primaryTeamsRecordingCTA);

    return (
      <ImageButton
        src={recordingCTA.recordingIcon}
        className="wall-content-icon wall-recording-icon"
        onClickHandler={handleClick}
        testID="wallRecordIcon"
        buttonContainerStyles="button-container"
        alt={recordingCTA.altHead}
        tooltipDirection="top"
      />
    );
  }, [
    primaryRecordingCTA,
    isTeamsPage,
    primaryTeamsRecordingCTA,
    handleTeamsRecordingAction,
    handleRecordingAction,
    primaryRecordingInfo,
    isTeamRecordingsEnabled,
  ]);

  /**
   * @param {Object} recordingInfo - Object containing response of particular asset from recordingsList object to compare the recording.
   * @param {String} typeOfRecording - SERIES
   */
  const editRecordingHandler = (recordingInfo, typeOfRecording) => {
    showRecordingSettingHandler(recordingInfo, typeOfRecording);
  };

  const onSeasonSelected = (item) => {
    if (item) {
      if (isSportSeries) {
        setCurrentSeasonIndex(
          modifiedGamesList?.findIndex((liveGame) => liveGame.metadata?.season === item.metadata?.season)
        );
      } else {
        loadSeasonEntitlements(appProvider, `${item.id}?season=${item.metadata?.season}`, isUserLoggedIn);
        logDTEvent(
          DT_EVENTS.SEASON_SELECT,
          {
            [DT_ATTRIBUTES.SEASON_NAME]: item.metadata?.season,
            [DT_ATTRIBUTES.SERIES_ID]: item.id,
          },
          isDynatraceTrackingEnabled
        );
        resetAction(LOAD_SEASON_ENTITLEMENTS, "content");
      }
    }
  };

  const getFavouriteButton = () => {
    return !isTeamsPage && isFavouritesEnabled && contentUserData?.metadata ? (
      <ImageButton
        src={isItemFavourite ? favourite_icon_active : favourite_icon}
        className="wall-content-icon"
        onClickHandler={isItemFavourite ? removeFavourite : addFavourite}
        alt={isItemFavourite ? translate("action_unfavourite") : translate("action_favourite")}
        tooltipDirection="top"
      />
    ) : null;
  };

  const getSeriesInfoButton = () => {
    return isTeamsPage && contentMetadata.metadata.seriesUaId ? (
      <ImageButton
        src={seriesInfoIcon}
        className="wall-content-icon"
        onClickHandler={() =>
          (window.location.href = `#${SERIES_DETAIL_PAGE.route}/PAGE/DETAILS/${PAGE_CONTENT_ITEM_TYPES.sportsSeries}/${contentMetadata.metadata.seriesUaId}`)
        }
        alt={translate("series_info")}
        tooltipDirection="top"
      />
    ) : null;
  };

  const getTeamItems = () => {
    const teamsContainer =
      seriesContainers?.length > 0 && findContainerByLayout(seriesContainers, CONTAINER_LAYOUTS.LIST_OF_TEAMS);
    const title = teamsContainer?.title;
    return createSwimlaneModels({
      data: listOfTeams.length > 20 ? listOfTeams.slice(0, 20) : listOfTeams,
      avsComponent: { metadata: { label: title }, title },
      addParams: {
        DIMENSIONS: ITEM_TYPES.TITLE_ITEM.LANDSCAPE.DIMENSIONS,
        viewAllUrl: `/viewall/TRAY/SEARCH/TEAMS?filter_uaSeriesId=${contentMetadata.metadata.seriesUaId}`,
      },
      itemsCount: listOfTeams.length,
      isAppLanguageFrench,
      userProfile,
    });
  };

  const getSimilarItems = () => {
    if (similarItems?.length > 0) {
      // Filtering out any items that point to the detail page we are currently on
      const filteredSimilarItems = similarItems.filter(
        (item) =>
          item?.actions?.find((action) => action?.key?.toLowerCase() === ACTION_KEYS.ON_CLICK)?.uri !== detailUri
      );
      const similarItemsContainer =
        seriesContainers?.length > 0 && findContainerByLayout(seriesContainers, CONTAINER_LAYOUTS.MORE_LIKE_THIS);

      if (filteredSimilarItems?.length > 0) {
        const title = similarItemsContainer?.title;
        return createSwimlaneModels({
          data: filteredSimilarItems,
          avsComponent: { metadata: { label: title }, title },
          addParams: { DIMENSIONS: ITEM_TYPES.TITLE_ITEM.PORTRAIT.DIMENSIONS, viewAllUrl },
          itemsCount: totalSimilarItems || filteredSimilarItems.length,
          isAppLanguageFrench,
          userProfile,
        });
      }
    }

    return null;
  };

  const getRecentAirings = () => {
    // Filtering out any items that point to the detail page we are currently on
    const filteredRecentAirings = recentAirings.filter(
      (item) => item?.actions?.find((action) => action?.key?.toLowerCase() === ACTION_KEYS.ON_CLICK)?.uri !== detailUri
    );
    const sortedRecentAirings = getSortedRecentAirings(filteredRecentAirings);
    const recentAiringsContainer =
      seriesContainers?.length > 0 && findContainerByLayout(seriesContainers, CONTAINER_LAYOUTS.RECENT_AIRINGS);

    if (sortedRecentAirings?.length > 0) {
      const title = recentAiringsContainer?.title;
      return createSwimlaneModels({
        data: sortedRecentAirings,
        avsComponent: { metadata: { label: title }, title },
        addParams: {
          DIMENSIONS: ITEM_TYPES.TITLE_ITEM.LANDSCAPE.DIMENSIONS,
          viewAllUrl: `/viewall/TRAY/SEARCH/VOD?filter_uaSeriesId=${contentMetadata.metadata.seriesUaId}${
            isTeamsPage ? `&filter_teamUmId=${contentMetadata.metadata.teamUmId}` : ""
          }&filter_contentType=VOD&title=${translate("recent_airings")}`,
        },
        itemsCount: sortedRecentAirings.length,
        isAppLanguageFrench,
        userProfile,
      });
    }

    return null;
  };

  let isItemFavourite = useMemo(() => contentUserData?.metadata?.favorites?.[0], [contentUserData]);
  isAPIcallFired.current = false;
  if (isAddedToFavourites !== null) {
    isItemFavourite = isAddedToFavourites;
  }

  const toastClickHandler = (type) => {
    if (type === "outHome") {
      showToastNotification(translate("message_in_home"), outHomeToastIcon);
    } else if (type === "geoblock") {
      showToastNotification(translate("error_program_not_available_region"));
    } else if (type === "browser") {
      showToastNotification(translate("error_browser_restriction"), null, {
        media: { isItemLive: false, ...contentMetadata },
      });
    } else if (type === "subscribe") {
      showToastNotification(translate("not_subscribed_restriction"), unSubscribedIcon, {
        media: { isItemLive: false, ...contentMetadata },
      });
    } else {
      return false;
    }
  };

  const preferredOption = getPreferredWatchOption(svodWatchOptions);

  const onPlayClick = (type, priorityEpisode) => {
    if (toastClickHandler(type) === false) {
      if (svodWatchOptions?.length > 1) {
        setShowWaysToWatch(true);
      } else {
        let play4KRestrictionInfo;
        if (is4KVodEnabled) {
          play4KRestrictionInfo = determine4KPlayRestriction(
            {
              hasUHD: priorityEpisode.metadata?.extendedMetadata?.isUHD,
              hasHDR: priorityEpisode.metadata?.extendedMetadata?.isHDR,
            },
            PLAY,
            preferredOption
          );
        }
        setSessionStorage(
          ANALYTICS_STORAGE_KEYS.LINK,
          `${LINK_INFO.ON_DEMAND_PLAY};${LINK_INFO.SUB_NAV};${getAAVideoPlayType()}`
        );
        performPlaybackChecks(
          priorityEpisode.userData,
          PLAYBACK_TYPES.EPISODE,
          priorityEpisode.metadata?.contentId,
          PAGE_CONTENT_ITEM_TYPES.vod,
          ON_DEMAND_PLAYER.route,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          play4KRestrictionInfo
        );
      }
    }
  };
  const getEntitlementType = (entitlement, episodeType) => {
    let label,
      icon,
      className = "",
      type;
    if (entitlement?.isChannelNotSubscribed) {
      label = "available_tv_mobile";
      icon = playIcon;
      className = "restricted";
      type = "browser";
    } else if (
      (entitlement?.isContentOOHBlocked || (isItemLive && !lookbackProgram && isLiveProgramOOH.current)) &&
      !isInHome
    ) {
      label = "action_ooh";
      icon = outHomeIcon;
      className = "restricted";
      type = "outHome";
    } else if (priorityEpisode?.userData?.entitlement?.isPlatformBlacklisted) {
      label = "";
      icon = playIcon;
      className = "restricted";
      type = "browser";
    } else if (
      entitlement?.isGeoBlocked // MVE1 feature
    ) {
      label = episodeType === "play" ? "available_tv_mobile" : "action_live";
      icon = playIcon;
      className = "restricted";
      type = "browser";
    } else if (entitlement?.isSportBlackoutBlocked) {
      label = "";
      icon = playIcon;
      className = "restricted";
      type = "browser";
    } else if (episodeType === "play") {
      let labelType;
      if (priorityEpisode.userData?.metadata?.bookmarks?.length > 0) {
        labelType = "resume";
      } else {
        labelType = "play";
      }
      const uaEpisodeObject = priorityEpisode.metadata && getAutoGeneratedObject(priorityEpisode.metadata);
      if (uaEpisodeObject.isSeasonAutoGenerated || uaEpisodeObject.isEpisodeAutoGenerated) {
        label = translate(`${labelType}_on_demand`);
      } else {
        label =
          priorityEpisode.metadata && priorityEpisode.metadata?.season
            ? priorityEpisode.metadata?.episodeNumber
              ? `${translate(labelType)} S${priorityEpisode.metadata?.season} E${
                  priorityEpisode.metadata?.episodeNumber
                } ${translate("on_demand")}`
              : `${translate(labelType)} S${priorityEpisode.metadata?.season} ${translate("on_demand")}`
            : priorityEpisode.metadata?.episodeNumber
            ? `${translate(labelType)} E${priorityEpisode.metadata?.episodeNumber} ${translate("on_demand")}`
            : translate(`${labelType}_on_demand`);
      }
      icon = playIcon;
      type = "play";
    } else if (lookbackProgram) {
      label = "restart_live_tv";
      icon = playIcon;
      className = "play";
    } else if (episodeType === "live") {
      label = "action_live";
      icon = playIcon;
      type = "live";
    } else if (entitlement?.isGeofencedBlocked) {
      label = "action_live";
      icon = playIcon;
      className = "play";
      type = "geofence";
    }
    return {
      label: label,
      icon: icon,
      className: className,
      type: type,
    };
  };

  const getPlayButton = () => {
    const entitlement = priorityEpisode.userData?.entitlement;
    const entitlementObj = getEntitlementType(entitlement, "play");
    return (
      <OptikButton
        label={translate(entitlementObj?.label)}
        icon={entitlementObj?.icon}
        className={entitlementObj?.className}
        onClickHandler={() => onPlayClick(entitlementObj?.type, priorityEpisode)}
      />
    );
  };

  const getLiveButton = () => {
    const entitlementObj = getEntitlementType(null, "live");
    const label = `${translate(entitlementObj?.label)}`;
    return (
      <OptikButton
        label={label}
        icon={entitlementObj?.icon}
        className={entitlementObj?.className}
        onClickHandler={() => handleLiveItemClick(entitlementObj?.type)}
      />
    );
  };

  const pageTitle = contentMetadata ? contentMetadata.Name : "";
  const handleLiveItemClick = (type) => {
    setSessionStorage(
      ANALYTICS_STORAGE_KEYS.LINK,
      `${LINK_INFO.LIVE_PLAY};${LINK_INFO.SUB_NAV};${getAAVideoPlayType()}`
    );
    if (toastClickHandler(type) === false) {
      performPlaybackChecks(
        null,
        null,
        lookbackProgram ? lookbackProgram.channel?.metadata?.channelId : liveItem.current?.channel?.channelId,
        PAGE_CONTENT_ITEM_TYPES.live,
        LIVE_PLAYER.route,
        null,
        null,
        lookbackProgram?.channel || null,
        null,
        lookbackProgram || null,
        null,
        null,
        { type: "", source: PLAY }
      );
    }
  };

  const isUnsubscribed = useMemo(() => {
    if (isUnSubscribeEpisodeSet && !isSubscribeEpisodeSet) return true;

    //Return true if channel is NOT subscribed
    if (schedules?.length && subscribedChannels && !checkIfAnyScheduleIsSubscribed(schedules, subscribedChannels)) {
      return true;
    }
    return false;
  }, [isSubscribeEpisodeSet, isUnSubscribeEpisodeSet, schedules, subscribedChannels]);

  const upSellComponent = useMemo(() => {
    const upSellLink = isAppLanguageFrench ? "telus.com/moncompte" : "telus.com/mytelus";
    const upSellText = translate("not_subscribed_restriction").split(upSellLink);

    return (
      <span>
        {upSellText[0]}
        <a href={`https://www.${upSellLink}`} target="_blank" rel="noopener noreferrer" className="series-up-sell-link">
          {upSellLink}
        </a>
        {upSellText[1]}
      </span>
    );
  }, [isAppLanguageFrench, translate]);

  const upSellString = useMemo(() => {
    return (
      <div className="series-up-sell-message">
        <img
          src={process.env.PUBLIC_URL + "/images/key-icon.svg"}
          className="series-up-sell-icon"
          alt={translate("subscribe")}
          data-testid="unsubscribedIcon"
        />
        {upSellComponent}
      </div>
    );
  }, [translate, upSellComponent]);

  const closeWaysToWatchPrompt = () => {
    setShowWaysToWatch(false);
  };

  const getSwimlaneRowNum = (feedTitle) => {
    const plusNum = (isSportSeries ? modifiedGamesList : seasonData)?.length ? 1 : 0;
    switch (feedTitle) {
      case SWIMLANE_TITLES.SIMILAR_ITEMS:
        return plusNum;
      case SWIMLANE_TITLES.CAST_AND_CREW:
        const swimlaneRowNum = similarItems ? 1 : 0;
        return swimlaneRowNum + plusNum;
      default:
        return null;
    }
  };

  const getLookbackAvailabilityElement = () => {
    return lookbackHoursLeft ? (
      <div className="lookback-string">{getLookbackAvailabilityString(lookbackHoursLeft)}</div>
    ) : null;
  };

  return loadComponent ? (
    <div className="detail-series">
      <SeoPageTags title={pageTitle} keywords={["optik", "telus"]} />
      {contentMetadata?.metadata && (
        <React.Fragment>
          <div className="series-wall-wrapper">
            <Wall
              cover={getAVSKeyArtImage(
                contentMetadata.metadata,
                IMAGES.ASPECT_RATIOS.DIM_9x16,
                isSportSeries || isTeamsPage
              )}
            />
            <div className="content-wrapper">
              <WallContent
                title={
                  isTeamsPage
                    ? contentMetadata.title
                    : contentMetadata.metadata.title || contentMetadata.metadata.seriesTitle
                }
                description={
                  isTeamsPage
                    ? contentMetadata.metadata.seriesTitle
                    : contentMetadata.metadata.longDescription || contentMetadata.metadata.seriesDescription
                }
                line1={!isSportSeries && !isTeamsPage && getSubTextLine1(contentMetadata, isAppLanguageFrench, true)}
                line2={getSubTextLine2(
                  priorityEpisode?.metadata || contentMetadata.metadata,
                  isAppLanguageFrench,
                  lookbackProgram?.metadata || liveSchedule?.metadata,
                  null,
                  null,
                  has4K.current,
                  is4KVodEnabled
                )}
                useInformationCluster={true}
                onInformationClusterClick={() => setShowMoreInformationModal(true)}
              >
                {!userProfile?.isLoggedIn && (
                  <div className="detail-page-cta login">
                    <OptikButton
                      label={translate("login")}
                      onClickHandler={() => {
                        setSessionStorage(ANALYTICS_STORAGE_KEYS.LINK, `${LINK_INFO.LOGIN};${LINK_INFO.SUB_NAV}`);
                        if (
                          appProvider.ENV === "avs-prod" ||
                          appProvider.ENV === "avs-beta" ||
                          !isAlternateLoginEnabled
                        ) {
                          handleLogin(
                            appProvider,
                            LOGIN_BRANDS.TELUS,
                            isKoodoLoginEnabled,
                            isDynatraceTrackingEnabled,
                            featureToggles.isPanicModeActive
                          );
                        } else {
                          // Redirect to alternate login page
                          history.push(ALTERNATE_LOGIN.route);
                        }
                      }}
                    />
                  </div>
                )}
                {/* fixed UI issue for button placement of live play */}
                <div className="wall-children">
                  {isUnsubscribed ? upSellString : null}
                  {priorityEpisode && !isSportSeries && !isTeamsPage ? (
                    <div className="detail-page-cta">{getPlayButton()}</div>
                  ) : null}
                  {(lookbackProgram || (isItemLive && liveItem.current !== 0)) && !isSportSeries && !isTeamsPage ? (
                    <div>
                      <div className="detail-page-cta live-btn">{getLiveButton()}</div>
                      {getLookbackAvailabilityElement()}
                    </div>
                  ) : null}
                  {(primaryRecordingCTA || (isTeamRecordingsEnabled && isTeamsPage && primaryTeamsRecordingCTA)) && (
                    <div className="recording-button-wrapper">
                      {getRecordingButton()}
                      {showRecordingCTALoading ||
                      (isTeamRecordingsEnabled && isTeamsPage && isTeamRecordingActionInProgress.current) ? (
                        <img
                          className="record-page-loading"
                          src={process.env.PUBLIC_URL + "/images/Rec_Progress.svg"}
                          alt=""
                        />
                      ) : null}
                    </div>
                  )}
                  {getFavouriteButton()}
                  {getSeriesInfoButton()}
                </div>
              </WallContent>
            </div>
          </div>
          <div>
            {showWaysToWatch ? (
              <WaysToWatchPrompt
                watchOptions={svodWatchOptions}
                closePrompt={closeWaysToWatchPrompt}
                vodPlaybackType={CONTENT_ITEM_TYPES.episode}
              />
            ) : null}
            {((seasonData && seasonData.length > 0) || listOfLiveGames?.length > 0) && (
              <div className="season-detail">
                <div className="season-dropdown">
                  <SeasonPickerDropDown
                    onSeasonDropDownSelected={onSeasonSelected}
                    currentSeasonIndex={isTeamsPage ? 0 : currentSeasonIndex}
                    isTeamsPage={isTeamsPage}
                    isSportSeries={isSportSeries}
                    sportsContent={isSportSeries && modifiedGamesList}
                    listOfLiveGamesCount={listOfLiveGames?.length}
                  />
                </div>
                <div>
                  {liveUAEpisodes?.length > 0 && (
                    <Swimlane
                      getSwimlaneRowNum={() => 0}
                      feed={getEpisodeList()}
                      dimensionConfig={ITEM_TYPES.TITLE_ITEM.EP_LIST_LANDSCAPE.DIMENSIONS}
                      sliderSettings={ITEM_TYPES.TITLE_ITEM.EP_LIST_LANDSCAPE.CONFIG}
                      ThumbnailComponent={EpisodeSwimlaneItem}
                      priorityEpisode={priorityEpisode}
                      isSportSeries={isSportSeries}
                      isMR={isMR}
                      recordablePrograms={recordablePrograms}
                      liveUAEpisodes={liveUAEpisodes}
                      recordingsList={recordingsList}
                      currentAndUpcomingSchedules={currentAndUpcomingSchedules}
                    />
                  )}
                </div>
              </div>
            )}
            {!isTeamsPage && listOfTeams?.length > 0 && (
              <div className="detail-swimlane">
                <Swimlane
                  feed={getTeamItems()}
                  dimensionConfig={ITEM_TYPES.TITLE_ITEM.LANDSCAPE.DIMENSIONS}
                  sliderSettings={ITEM_TYPES.CHARACTER_ITEM.CONFIG}
                  ThumbnailComponent={SwimlaneItem}
                />
              </div>
            )}
            {(isTeamsPage || isSportSeries) && filteredRecordings?.length > 0 && (
              <div className="episode-swimlane">
                <Swimlane
                  feed={getRecentRecordingItems()}
                  dimensionConfig={ITEM_TYPES.TITLE_ITEM.LANDSCAPE.DIMENSIONS}
                  sliderSettings={ITEM_TYPES.CHARACTER_ITEM.CONFIG}
                  ThumbnailComponent={SwimlaneItem}
                />
              </div>
            )}
            {(isTeamsPage || isSportSeries) && recentAirings?.length > 0 && (
              <div className="detail-swimlane">
                <Swimlane
                  feed={getRecentAirings()}
                  dimensionConfig={ITEM_TYPES.TITLE_ITEM.LANDSCAPE.DIMENSIONS}
                  sliderSettings={ITEM_TYPES.CHARACTER_ITEM.CONFIG}
                  ThumbnailComponent={SwimlaneItem}
                />
              </div>
            )}
            {similarItems?.length > 0 && (
              <div className="detail-swimlane">
                <Swimlane
                  getSwimlaneRowNum={() => getSwimlaneRowNum(SWIMLANE_TITLES.SIMILAR_ITEMS)}
                  feed={getSimilarItems()}
                  dimensionConfig={ITEM_TYPES.TITLE_ITEM.PORTRAIT.DIMENSIONS}
                  sliderSettings={ITEM_TYPES.CHARACTER_ITEM.CONFIG}
                  ThumbnailComponent={SwimlaneItem}
                />
              </div>
            )}

            {contentMetadata.metadata.extendedMetadata?.dlum?.people?.length > 0 && (
              <div className="detail-swimlane cast">
                <Swimlane
                  getSwimlaneRowNum={() => getSwimlaneRowNum(SWIMLANE_TITLES.CAST_AND_CREW)}
                  feed={getRolesFeed()}
                  dimensionConfig={ITEM_TYPES.CHARACTER_ITEM.DIMENSIONS}
                  sliderSettings={ITEM_TYPES.CHARACTER_ITEM.CONFIG}
                  ThumbnailComponent={CastSwimlaneItem}
                />
              </div>
            )}
            {showRecordingModal && (
              <RecordingModal
                closeModal={closeRecordingModal}
                scheduleRecordingHandler={scheduleRecording}
                recordingInfo={selectedAssetRecordingInfo}
                editRecordingHandler={editRecordingHandler}
              />
            )}
            {showMoreInformationModal && (
              <MoreInformationModal
                {...mapMoreInformationModalProps(
                  isTeamsPage,
                  contentMetadata,
                  isAppLanguageFrench,
                  priorityEpisode,
                  lookbackProgram,
                  liveSchedule,
                  isLookbackEnabled ? schedules : currentAndUpcomingSchedules,
                  channelMapInfo,
                  isItemLive
                )}
                onClose={() => setShowMoreInformationModal(false)}
                isAppLanguageFrench={isAppLanguageFrench}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  ) : (
    <></>
  );
}

SeriesDetailPage.propTypes = {
  appProvider: PropTypes.object,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  resetAction: PropTypes.func.isRequired,
  loadSimilarItems: PropTypes.func.isRequired,
  similarItems: PropTypes.array,
  featureToggles: PropTypes.object,
};

function mapStateToProps({ app, seriesDetails, feed, recording }) {
  return {
    userProfile: app.userProfile,
    appProvider: app.provider,
    feedItems: feed.content,
    similarItems: seriesDetails.similarItems,
    subscribedChannels: app.subscribedChannels,
    seasonData: seriesDetails.seasonDetails,
    firstEpisodeData: seriesDetails.firstEpisodeData,
    seasonEntitlements: seriesDetails.seasonEntitlements,
    recordingsList: recording.recordingsList,
    getRecordingError: recording.getRecordingError,
    setRecordingResponse: recording.setRecordingResponse,
    editRecordingResponse: recording.editRecordingResponse,
    deleteRecordingResponse: recording.deleteRecordingResponse,
    manipulatedRecordingParams: recording.manipulatedRecordingParams,
    totalSimilarItems: seriesDetails.totalSimilarItems,
    isAddedToFavourites: app.isAddedToFavourites,
    schedules: seriesDetails.schedules,
    contentUserData: seriesDetails.contentUserData,
    isInHome: app.isInHome,
    featureToggles: app.featureToggles,
    channelMapInfo: app.channelMapInfo,
    listOfTeams: seriesDetails.listOfTeams,
    recentAirings: seriesDetails.recentAirings,
    listOfLiveGames: seriesDetails.listOfLiveGames,
    seriesContainers: seriesDetails.containers,
  };
}

const mapDispatchToProps = {
  loadTVShowDetailItems,
  resetAction,
  loadSimilarItems,
  addFavourites,
  deleteFavourites,
  loadUserSubscribedChannels,
  showToastNotification,
  loadContentUserData,
  loadSeasons,
  loadSchedules,
  loadSeasonEntitlements,
  setRecordingAction,
  getRecordingAction,
  setConvivaContentSubType,
  showModalPopup,
  showRecordingSettingsPanel,
  toggleSettingsPanelAction,
  loadChannels,
};

export default connect(mapStateToProps, mapDispatchToProps)(SeriesDetailPage);

const is4KChan = (programSchedules, channelMapInfo) => {
  return programSchedules?.some((schedule) => {
    const channelObj = channelMapInfo?.containers?.find(
      (channel) => parseInt(channel?.id) === schedule?.channel?.channelId
    );
    return is4KChannel(channelObj);
  });
};

/**
 * Method to compare two season objects with season number.
 * @param {Object} currentSeason
 * @param {Object} seasonToCompare
 * @returns {Boolean}
 */
const getCheckForEntitlementCall = (currentSeason, seasonToCompare) =>
  currentSeason?.metadata?.season !== seasonToCompare?.metadata?.season;

/**
 * Function to map badges for more information modal
 * @param {Object} contentDetails metadata object of the content
 * @param {Object} firstLiveProgram metadata object of the first live schedule of the content
 * @param {Object} programSchedules object containing showtimes of the content
 * @param {Object} channelMapInfo array of channels available for the user
 * @param {Object} isItemLive boolean to indicate if content is live
 * @returns {Object} badge props object for more information modal
 */
const mapMoreInformationModalBadges = (
  contentDetails,
  firstLiveProgram,
  programSchedules,
  channelMapInfo,
  isItemLive
) => {
  const extendedMetadata = contentDetails?.extendedMetadata;
  return {
    isCCAvailable: extendedMetadata?.hasCC || firstLiveProgram?.extendedMetadata?.hasCC,
    isDVAvailable: extendedMetadata?.hasDV || firstLiveProgram?.extendedMetadata?.hasDV,
    isHDR: extendedMetadata?.hasHDR,
    is4K: is4KChan(programSchedules, channelMapInfo),
    isUHD: extendedMetadata?.hasUHD,
    isNew: firstLiveProgram?.extendedMetadata?.epg?.isNew,
    isLive: isItemLive || firstLiveProgram?.extendedMetadata?.epg?.isLive,
  };
};

/**
 * Function to map props for more information modal
 * @param {Boolean} isTeamsPage boolean to indicate if content is of unified sports' teams type
 * @param {Object} contentMetadata object containing metadata of the content
 * @param {Boolean} isAppLanguageFrench boolean to indicate if app language is french
 * @param {Object} priorityEpisode object containing details of priority episode of the tv show
 * @param {Object} lookbackProgram object containing details of first lookback schedule of the tv show
 * @param {Object} liveSchedule object containing details of first live schedule of the content
 * @param {Object} programSchedules object containing showtimes of the content
 * @param {Array} channelMapInfo array of channels available for the user
 * @param {Boolean} isItemLive boolean to indicate if content is live
 * @returns {Object} props object for more information modal
 */
const mapMoreInformationModalProps = (
  isTeamsPage,
  contentMetadata,
  isAppLanguageFrench,
  priorityEpisode,
  lookbackProgram,
  liveSchedule,
  programSchedules,
  channelMapInfo,
  isItemLive
) => {
  const { metadata, containers } = contentMetadata;
  const { extendedMetadata } = metadata;

  const getEpisodesInfo = () => {
    const seasonLabel = containers.length === 1 ? i18n.t("season") : i18n.t("seasons");
    const seasonInfo = `${containers.length} ${seasonLabel}`;
    const episodeCount = containers.reduce((numEpisodes, nextEpisode) => {
      return numEpisodes + nextEpisode.metadata?.episodeCount;
    }, 0);
    const episodeLabel = episodeCount === 1 ? i18n.t("episode") : i18n.t("episodes");
    const episodeInfo = `${episodeCount} ${episodeLabel}`;
    return `${seasonInfo}, ${episodeInfo}`;
  };
  const rottenTomatoesScores = priorityEpisode?.metadata?.extendedMetadata?.dlum?.rt || extendedMetadata?.dlum?.rt;
  const cinocheRatings = priorityEpisode?.metadata?.extendedMetadata?.dlum?.cinoche || extendedMetadata?.dlum?.cinoche;
  return {
    title: isTeamsPage ? contentMetadata?.title : metadata?.title || metadata?.seriesTitle,
    description: isTeamsPage ? metadata?.seriesTitle : metadata?.longDescription || metadata?.seriesDescription,
    rating: extendedMetadata?.dlum?.rating,
    availableEpisodes: containers ? getEpisodesInfo() : null,
    runtime: getDurationInMinHour(metadata),
    year: metadata?.year,
    genres: isAppLanguageFrench ? extendedMetadata?.dlum?.displayGenresFra : extendedMetadata?.dlum?.displayGenres,
    criticImage: rottenTomatoesScores?.criticImage,
    fanImage: rottenTomatoesScores?.fanImage,
    criticScore: rottenTomatoesScores?.criticScore,
    fanScore: rottenTomatoesScores?.fanScore,
    criticRating: cinocheRatings?.criticScore,
    memberRating: cinocheRatings?.fanScore,
    ...mapMoreInformationModalBadges(
      priorityEpisode?.metadata || metadata,
      lookbackProgram?.metadata || liveSchedule?.metadata,
      programSchedules,
      channelMapInfo,
      isItemLive
    ),
  };
};
